export default __webpack_public_path__ + "static/media/author-banner.f87f28ac.png";